import {Pipe, PipeTransform} from '@angular/core';
import {DecimalPipe} from '@angular/common';
import {AppConfigService} from '../../Services/app-config.service';

@Pipe({
  name: 'decimal',
  standalone: false
})

export class DecimalNewPipe implements PipeTransform {

  constructor(private decimal: DecimalPipe, private appConfigService: AppConfigService) {

  }

  transform(value: any) {
    // Allow zero to display (0.00, etc.). Only treat null/undefined/empty/NaN as empty.
    if (value === null || value === undefined || value === '') {
      return '';
    }
    const num = Number(value);
    if (Number.isNaN(num)) {
      return '';
    }
    const decimalPlaces = this.appConfigService.decimalPlaces;
    const digitsInfo = '1.' + decimalPlaces + '-' + decimalPlaces;
    return this.decimal.transform(num, digitsInfo);
  }

}
